export default "__VITE_ASSET__BnH$hgIO__"